import { Flex, Link, Text } from '@chakra-ui/react'
import React from 'react'

export const FeatureRequestsCard = () => {
  return (
    <Link
      textDecoration="none"
      _hover={{ cursor: 'pointer' }}
      href="https://blueprint-health.canny.io/ai-notetaker"
      isExternal
      _focus={{ outline: 'none' }}
    >
      <Flex
        p="16px"
        border="1px solid"
        borderColor="pale_gray"
        borderRadius="8px"
        gap="16px"
        bg="white"
        boxShadow="0px 2px 8px 0px #00000014"
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          h="44px"
          w="44px"
          bg="primary"
          borderRadius="8px"
        >
          <svg
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Feature request icon</title>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.04 2.5L19.45 3.91L17.66 5.71L16.25 4.3L18.04 2.5ZM10 3H12V0H10V3ZM19 12H22V10H19V12ZM10 14.99V17.95H12V14.99L13 14.41C14.23 13.69 15 12.37 15 10.95C15 8.74 13.21 6.95 11 6.95C8.79 6.95 7 8.74 7 10.95C7 12.37 7.76 13.69 9 14.41L10 14.99ZM14 19.95L8 19.95V16.14C6.21 15.1 5 13.17 5 10.95C5 7.64 7.69 4.95 11 4.95C14.31 4.95 17 7.64 17 10.95C17 13.17 15.79 15.1 14 16.14V19.95ZM0 12H3L3 10H0V12ZM3.97 2.49L5.76 4.29L4.36 5.69L2.56 3.9L3.97 2.49ZM8 23.0001C8 23.5501 8.45 24.0001 9 24.0001H13C13.55 24.0001 14 23.5501 14 23.0001V22.0001H8V23.0001Z"
              fill="white"
            />
          </svg>
        </Flex>
        <Flex flexDirection="column">
          <Text>Have a feature request?</Text>
          <Text color="primary">Submit your idea</Text>
        </Flex>
      </Flex>
    </Link>
  )
}
